export const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const getUserLanguage = (): string => {
  try {
    // @ts-expect-error - `getCanonicalLocales` not TS supported but has browser support
    return Intl.getCanonicalLocales(window.navigator.language)[0]
  } catch {
    return 'en-US'
  }
}
